
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FurtherAddressesEditor.html?raw';
import _TabEnabledMixin from '../../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import _StatefulSection from '../../../../moreCore/UI/_StatefulSection/_StatefulSection';
import { AddressTypes } from "../../../_loadingHelpers/Address";
import HintBox from '../../../../moreCore/UI/EntityBased/HintBox/HintBox';
import Edit from '../../../../moreCore/UI/Edit/Edit';


class FurtherAddressesEditor extends compose(_TabEnabledMixin, _StatefulSection) {
    templateString: any = template;

    private addressId: string;
    private postalCodeHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private cityHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private countryHintbox: MdsLax<InstanceType<typeof HintBox>>;
    private descriptionInput: MdsLax<InstanceType<typeof Edit>>;


    isValid(): boolean {  

        if (!this.descriptionInput.validateInput()) return false;

        return true;
    }
    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        this.fillUpPostalCode();
    }

    private fillUpPostalCode(): void {

        let postalCode = this.getAttributeValue("ref_postal_code");

        if (postalCode) {
            this.postalCodeHintbox.setValue(postalCode, true);
            this.cityHintbox.setValue(postalCode, true);
        } else {
            this.postalCodeHintbox.setValue(this.getAttributeValue("c_postal_code"), true);
            this.cityHintbox.setValue(this.getAttributeValue("c_city"), true);
        }
    }

    _onChanged(key: string, value: any): void {

        switch (key) {
            case "hintbox_postal_code":
                this._onValueChange_postalCode(value);
                break;
            case "hintbox_city":
                this._onValueChange_city(value);
                break;
        }
    }

    private _onValueChange_postalCode(value: any): void {

        if (value != null && typeof value == "object") {
            
            this.cityHintbox.setValue(value, true);
            this.countryHintbox.setValue(value.ref_country, true);
            this.setAttributeValue("hintbox_city", value);
        } else {

            if (this.cityHintbox.getValue("entity")) this.cityHintbox.setValue(null, true);
        }

        this.UiModder.domClass.toggle(this.countryHintbox.domNode, "w3-disabled", typeof value != "string");
    }

    private _onValueChange_city(value: any): void {

        if (value != null && typeof value == "object") {

            this.postalCodeHintbox.setValue(value, true);
            this.countryHintbox.setValue(value.ref_country, true);
            this.setAttributeValue("hintbox_postal_code", value);
        } else {

            if (this.postalCodeHintbox.getValue("entity")) this.postalCodeHintbox.setValue(null, true);
        }

        this.UiModder.domClass.toggle(this.countryHintbox.domNode, "w3-disabled", typeof value != "string");
    }
    setAddressId(addressId: string) {

        this.addressId = addressId;
    }

    applyAllreadyChangedData(data: AddressTypes.FurtherAddressesEntry) {

        for (let p in data) {
            switch (p) {
                case "ref_postal_code":
                    if (data.ref_postal_code != null) {

                        this.setAttributeValue("hintbox_postal_code", data.ref_postal_code);
                        this.setAttributeValue("hintbox_city", data.ref_postal_code);
                    } else {

                        this.setAttributeValue("hintbox_postal_code", data.c_postal_code);
                        this.setAttributeValue("hintbox_city", data.c_city);
                    }
                    break;
                default:
                    this.setAttributeValue(p, data[p]);
            }
        }
    }
    externalEventHandler(event: "ok") {

        switch (event) {
            case "ok":
                this._onClicked_OK();
                break;
            default:
                this._showErrorMessage(`Wrong external event! **${event}** event not supported!`)
        }
    }
    private _onClicked_OK() {

        var jsonData = {
            ID: this.entityId,
            changedData: this.changedData
        }

        if (this.isValid()) {
            this.emit("okClicked", jsonData);
        } else {
            this.showToast(this.translate("General_Error_InvalidData"), "fas fa-exclamation-triangle");
        }
    }
    setNewEntityId(ID: string) {

        this.entityId = ID;
    }
    private _showErrorMessage(msg?: string) {
        var errorMessage = msg ? msg : "...error occured";
        this.showToast(errorMessage, "fas fa-exclamation-triangle");
    }
    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.resetDirty();
    }
}

export default mdsWidget(FurtherAddressesEditor);